<div class="value-props">
  <div *ngFor="let valueProp of valueProps" class="value-prop-container">
    <div class="value-prop-image-container">
      <img class="value-prop-image" src="{{ valueProp.image }}" alt="" />
    </div>
    <p class="value-prop-copy text-wrap">{{ valueProp.copy }}</p>
  </div>
</div>
